import { Image } from 'ui';

const fixedHeight = '400px';

export const GuideImage = ({ src, alt, height = 'auto' }: { src: string; alt: string; height?: 'auto' | 'fixed' }) => {
  return (
    <Image
      src={src}
      alt={alt}
      rounded
      sx={{
        height: height === 'fixed' ? fixedHeight : 'auto',
        objectFit: 'contain',
      }}
    />
  );
};
